import { AutoComplete, AutoCompleteProps, Input } from "antd";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  AuthenticationState,
  UserInterface,
} from "../../../../interfaces/users";
import { useQuery } from "react-query";
import { api } from "../../../../config";
import { useSelector } from "react-redux";

interface SearchAssemblersProps {
  disabled?: boolean;
  onSearch?: () => void;
  assembler: number | undefined;
  setAssembler: Dispatch<SetStateAction<number | undefined>>;
  type?: "Líder" | "Montador" | "Agendado por";
}

export const SearchAssemblers: React.FC<SearchAssemblersProps> = ({
  disabled,
  onSearch,
  assembler,
  setAssembler,
  type = "Montador",
}) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { data: users, isFetching: isFetchingUsers } = useQuery<
    UserInterface[]
  >(`users-assemble-${type}`, () =>
    api(token).get(
      type === "Montador"
        ? `/users?moduleName=ASSEMBLE_APP&permission=USER` +
            (assembler ? `&ids=${assembler}` : "")
        : `/users?moduleName=ASSEMBLE&permission=USER,ADMIN` +
            (assembler ? `&ids=${assembler}` : "")
    )
  );
  const [options, setOptions] = useState<AutoCompleteProps["options"]>([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!assembler) {
      setSearchText("");
      return;
    }

    const selectedUser = users?.find((user) => user.id === assembler);
    if (selectedUser) {
      setSearchText(selectedUser.fullName);
    }
  }, [assembler, users]);

  const getPanelValue = (text: string) => {
    return users
      ?.filter((user) =>
        user.fullName.toLowerCase().includes(text.toLowerCase())
      )
      .map((user) => ({ value: user.fullName, label: user.fullName }));
  };

  return (
    <AutoComplete
      options={options}
      style={{ width: 200 }}
      value={searchText}
      onSelect={(value) => {
        const user = users?.find((user) => user.fullName === value);
        setSearchText(value);

        setAssembler(user ? user.id : undefined);
      }}
      onSearch={(text) => {
        setSearchText(text);
        setOptions(getPanelValue(text));
      }}
    >
      <Input.Search
        placeholder={`Buscar ${type}`}
        enterButton
        // allowClear
        value={searchText}
        onChange={(e) => {
          const text = e.target.value;
          setSearchText(text);
          if (!text) {
            setAssembler(undefined);
          }
        }}
        onSearch={(text) => {
          if (!text && assembler) return;
          onSearch?.();
        }}
        disabled={disabled || isFetchingUsers}
      />
    </AutoComplete>
  );
};
